import {gsap} from "gsap";


const animationOnce = (container) => {
    // console.log("Default animation ONCE");

    // Element à animer



    // Gsap timeline
    const tl = gsap.timeline({
        defaults : {
            duration: 1,
            ease: "power1.out",
        },
        delay:.8,
    });

    tl.to(container, {alpha:1})


    //pour dev
    tl.timeScale( 1 );
    return tl;
}

export default animationOnce;
